function Results() {
  return (
    <div className="max-w-screen-md m-auto bg-mediumGrey p-12 rounded-md mt-10"></div>
  );
}

export default Results;
